<div class="flex flex-col min-h-screen" style="width: 400px; min-height: 200px;">
    <div class="publisher-dialog-header">
        <span class="font-600 text-[16px]">{{this.title}} <span class="publish-count">{{ totalItem
                }}</span></span>
        <div class="dialog-header-icon gap-2">
            <button (click)="getPublisherList()">
                <svg-icon svgClass="icon-24" src="/assets/icons/publish.svg" />
            </button>
            <button (click)="close()">
                <svg-icon svgClass="icon-32" src="/assets/icons/close.svg" />
            </button>
        </div>
    </div>
    @if(loading){
    <div class="spinner-container">
        <div class="spinner"></div>
    </div>
    }
    @if (publisherItem.length < 1 && !loading) { <div class="flex flex-col items-center justify-center p-3"
        style="min-height: 352px;">
        <svg-icon src="/assets/images/success.svg" />
        <span class="text-[20px] py-5" i18n="@@publisher.noresult.dialog.title">You’re up to date!</span>
        <span class="text-center gs-text" i18n="@@publisher.noresult.dialog.description">New items will appear here when changes are made in the portal.</span>
</div>
} @else {
<ng-container>
    <div class="flex flex-col publisher-body" style="min-height: 200px;">
        @if (infoMsg && !loading && !errorMsg) {
        <p-card styleClass="info-card">
            <span class="hint-text" i18n="@@publisher.info.dialog.description">New items will appear here when changes are made in the portal. Publishing
                will
                set them live in production and is a permanent action.</span>
            <div class="py-2 flex justify-end">
                <button (click)="handleMessageClose()" class="button-meta-text" i18n="@@publisher.button.dismiss">Dismiss</button>
            </div>
        </p-card>
        }
        @if (errorMsg && !loading && errorList.length > 0) {
        <p-card styleClass="error-card">
            <span class="hint-text" i18n="@@publisher.error.dialog.description">Unable to publish all the items you selected due to the following
                reasons:</span>
            <ul class="hint-text list-disc ml-5">
                @for (item of errorList; track item;) {
                <li>{{item.errorCode}} - {{item.errorMessage}}</li>
                }
            </ul>
            <div class="py-2 flex justify-end">
                <button (click)="errorMsg=!errorMsg;infoMsg = false" class="font-600" i18n="@@publisher.button.dismiss">Dismiss</button>
            </div>
        </p-card>
        }
        @for (item of publisherItem; track item; let index = $index) {
        @if (item.events.length > 0) {
        <p-panel styleClass="publisher-panel" #panel [header]="formatName(item.name) + ' ('+item.events.length+')'" [toggleable]="true">
              <ng-template pTemplate="headericons" let-collapsed>
                <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
            </ng-template>
            <ng-template pTemplate="header">
                <span class="accordion-action" (click)="$event.stopPropagation();">
                    <p-checkbox [(ngModel)]="item.selectAll" [disabled]="checkDisabled(item.name)" binary="true"
                        [name]="item.name" (onChange)="toggleSelectAll(item)" />
                </span>
            </ng-template>
            <div class="border-top pt-2">
                @for (subItem of item.events; track subItem; let index = $index) {
                <div class="flex justify-between pt-2 hint-text">
                    <div class="text-body">
                        @if(subItem.eventSourceName.length > 35){
                        <button class="text-blue-500 font-700 text-left" [pTooltip]="subItem.eventSourceName" (click)="routeItem(subItem)"  tooltipPosition="top">{{subItem.eventSourceName.substring(0, 35)}}...</button>
                        }@else{
                        <button class="text-blue-500 font-700 text-left" (click)="routeItem(subItem)">{{subItem.eventSourceName}}</button>
                        }
                        {{formatContent(subItem)}}                   
                    </div>
                    <p-checkbox [disabled]="subItem.disabled" [(ngModel)]="item.selectedItems"
                        [name]="subItem.uuid" (onChange)="toggleCheck(item, subItem, subItem.checked)" [value]="subItem.uuid" />
                </div>
                }
            </div>
        </p-panel>
        }
        }
    </div>

    <div class="flex flex-col fixed bottom-0 w-full">
        @if(errorMsg){
        <div class="publisher-result color-red">
            <span class="hint-text color-red" i18n="@@publisher.error.toast">Oops! An error occurred. Refresh & try again.</span>
            <svg-icon svgClass="icon-32" src="/assets/icons/alert-circle.svg" />
        </div>
        }
        @if(successMsg){
        <div class="publisher-result">
            <span class="hint-text" i18n="@@publisher.info.toast">Publishing of {{ publishSubmittedCount() }} item{{ publishSubmittedCount() > 1 ? 's' : '' }} successful!</span>
            <svg-icon svgClass="icon-24" src="/assets/icons/publisher-success.svg" />
        </div>
        }
        @if (publishingMsg) {
        <div class="publisher-result">
            <span class="hint-text" i18n="@@publisher.success.toast">Publishing {{ getOverallSelectedCount() }} item{{ getOverallSelectedCount() > 1 ? 's' : '' }} in progress...</span>
        </div>
        }
        <div class="publisher-dialog-footer">
            @if(!this.publishingMsg){
            <button pButton severity="primary" [disabled]="getOverallSelectedCount() < 1" (click)="publish()" i18n-label="@@publisher.button.publish.items" class="w-48"
                [label]="this.btnPublish + (getOverallSelectedCount() > 0 ? ' ' + getOverallSelectedCount() + ' ' + (getOverallSelectedCount() > 1 ? this.items : this.item) : '')"></button>
            } @else {
            <button pButton severity="primary" class="w-48" label="Publishing" i18n-label="@@publisher.button.publishing" [loading]="btnLoading"
                iconPos="right"></button>
            }

        </div>
    </div>
</ng-container>
}
</div>